<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="3"></ucMenu>
					<div class="right_con">
						<div class="goods_main" >
							<p class="fb">订单列表</p>
							<div class="select_wrap">
								<!-- <el-select class="w290" v-model="searchData.shop_type" placeholder="请选择" clearable filterable >
									<p slot="prefix" class="label_title">店铺类型</p>
									<el-option v-for="item in shopTypeList" :key="item.val" :label="item.text" :value="item.val">
									</el-option>
								</el-select> -->
								<el-select class="w290" v-model="searchData.shop_id" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">店铺名</p>
									<el-option v-for="item in arrShop" :key="item.key" :label="item.key" :value="item.val">
									</el-option>
								</el-select>
								<el-input class="w290" v-model="searchData.order_no" placeholder="请输入订单编号" clearable>
									<p slot="prefix" class="label_title">订单编号</p>
								</el-input>
								<el-input class="w290" v-model="searchData.goods_id" placeholder="请输入商品ID" clearable>
									<p slot="prefix" class="label_title">商品ID</p>
								</el-input>
								<el-select class="w290" v-model="searchData.order_status" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">订单状态</p>
									<el-option v-for="item in arrStatus" :key="item.val" :label="item.text" :value="item.val">
									</el-option>
								</el-select>
								<el-select class="w290" v-model="searchData.after_sale_status" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">售后状态</p>
									<el-option v-for="item in arrAfterSales" :key="item.val" :label="item.text" :value="item.val">
									</el-option>
								</el-select>

								<el-select class="w290" v-model="searchData.seller_remark_stars" placeholder="请选择" clearable>
									<el-tooltip slot="prefix" class="item" effect="dark" content="可筛选订单号后带有标记的订单" placement="top">
										<p class="label_title">订单标记<i class="iconfont icon-shuoming"></i></p>
									</el-tooltip>
									<el-option v-for="item in arrStar" :key="item.val" :label="item.text" :value="item.val">
										<span style="float: left">{{ item.text }}</span>
										<span style="float: right;"><i :class="item.icon" :style="[{color:item.color}]"></i></span>
									</el-option>
								</el-select>
								<el-input class="w290" v-model="searchData.express_no" placeholder="请输入物流单号" clearable>
									<p slot="prefix" class="label_title">物流单号</p>
								</el-input>
								<el-input class=" w290" v-model="searchData.buyer_name" placeholder="请输入收货人姓名" clearable>
									<p slot="prefix" class="label_title">收货人</p>
								</el-input>
								<el-input class="w290" v-model="searchData.buyer_phone" placeholder="请输入收货人手机号" clearable>
									<p slot="prefix" class="label_title">手机号码</p>
								</el-input>
								<el-date-picker class="w290"
									v-model="searchData.search_date"
									type="datetimerange"
									align="right"
									unlink-panels
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									value-format="yyyy-MM-dd HH:mm:ss"
									@onPick="datePick"
									:picker-options="pickerOptions"
									:default-time="['00:00:00', '23:59:59']">
								</el-date-picker>

								<el-button plain size="small" @click="getList()">查询</el-button>
								<el-button plain size="small" @click="resetSearch()">重置</el-button>
							</div>
							<div class="tabs_wrap">
								<p class="tab" :class="!searchData.order_status?'active':''" @click="changeStatus('')">全部</p>
								<p class="tab" :class="searchData.order_status==s.val?'active':''" v-for="(s,i) in arrStatus" :key="i" @click="changeStatus(s.val)">{{s.text}}<el-badge class="mark" :value="s.num" v-if="s.num > 0"/></p>
								<!-- <p class="tab">已签收未确认<i class="iconfont icon-clock"></i></p>
								<p class="tab">已确认未评价<i class="iconfont icon-clock"></i></p> -->
							</div>
							<div class="totals_btn">
								<p class="totals">共{{page_data.total}}条</p>
								<el-button plain size="small" @click="bindBatPurchase()">批量采购</el-button>
								<el-button plain size="small" @click="orderExport()">批量导出</el-button>
								<!-- <el-button plain size="small" @click="dialog.syncOrderDialog=true">同步订单</el-button> -->

							</div>
							<div class="list_title">
								<label class="checkall">
									<el-checkbox v-model="checkAll" @change="bindCheckAll">全选</el-checkbox>
								</label>
								<p class="t1">货品信息<i class="iconfont el-icon-view" style="font-size: 14px;margin-left: 5px;cursor: pointer;" @click="showOrderInfo()"></i></p>
								<p class="t2">售价/数量</p>
								<p class="t3">售后状态</p>
								<p class="t4">应付</p>
								<p class="t5">买家/收货人</p>
								<!-- <p class="t6">采购状态</p> -->
								<p class="t7">操作</p>
							</div>
							<ul class="order_list">
								<el-checkbox-group v-model="checkList" @change="bindCheckList">
									<li v-for="(item,index) in list" :key="index">
										<div class="order_nums">
											<div class="check_box"><el-checkbox :label="item.order_id" :key="item.order_id" :checked="item.checked"></el-checkbox></div>
											<p class="num" v-if="item.shop_type==1 && item.dd_shop"><span class="shop_name">{{ isHideOrderInfo ? '************' : item.dd_shop.shop_name}}</span>抖店单号：{{item.dd_order_id}}<i class="iconfont icon-fuzhi" @click="bindCopy(item.dd_order_id)"></i></p>

											<p class="num" v-if="item.shop_type==2 && item.dd_shop"><span class="shop_name">{{item.dd_shop.shop_name}}</span>快店单号：{{item.dd_order_id}}<i class="iconfont icon-fuzhi" @click="bindCopy(item.dd_order_id)"></i></p>
											<p class="num" v-if="item.shop_type!=0 && !item.dd_shop"><span class="shop_name">店铺已删除</span>：{{item.dd_order_id}}<i class="iconfont icon-fuzhi" @click="bindCopy(item.dd_order_id)"></i></p>

											<p class="num" v-if="item.shop_type==0">平台单号：{{item.order_no}}<i class="iconfont icon-fuzhi" @click="bindCopy(item.order_no)"></i></p>
											<p class="date">下单时间：{{item.create_time}}</p>
											<p class="maoli">买家备注：{{item.buyer_words}}</p>
											<i v-if="item.dd_order_id!='0'" class="btn-remark el-icon-s-flag" @click="showRemark(item.order_id)" :style="{'color':item.seller_remark_starts_info.color}"></i>
										</div>
										<div class="order_info">
											<div class="order_product">
												<div class="product_item"  v-for="(product,pindex) in item.order_product">
													<div class="goods_info">
														<div class="img_box">
															<el-image
																	:src="product.product_pic"
																	:preview-src-list="[product.product_pic]"
															/>
		<!--                              <img class="coverimg" :src="product.product_pic" />-->
														</div>
														<div class="con_box">
															<p class="title">{{ isHideOrderInfo ? '************' : product.product_name}}</p>
															<p class="t1" v-if="product.goods_id">商品ID：{{product.goods_id}}</p>
															<p class="t2">{{product.spec_value}}</p>
															<p class="t2" v-if="product.supplier">供应商：{{product.supplier.nickname}}</p>
															<p class="stock_msg" v-if="product.purchase_status==2">
																<span>采购价：{{ product.product_cost_price ?? '0.00' }}</span>
																<span>代发费：{{ product.freight_price }}</span>
															</p>
															<p class="stock_msg" v-if="product.purchase_status==2">
																<span>毛利润：{{ product.total_profit }}</span>
															</p>
														</div>
													</div>
													<div class="goods_num">
														<p class="t1">{{product.item_amount}}</p>
														<p class="t2">x{{product.item_num}}</p>
													</div>
													<div class="goods_sales">
														<p>{{product.order_status_text}}</p>
														<p class="warning" v-if="product.lack_type">{{product.lack_type_text}}{{product.lack_day>0?(product.lack_day+'天'):''}}</p>

														<p class="red" v-if="product.order_after_sales" @click="showAfterSaleInfo(product)">
															<span v-if="product.order_after_sales.refund_type==2&&product.order_after_sales.refund_status==3&&product.order_after_sales.supplier_pass==2">售后完成,供应商拒绝退款</span>
															<span v-else>{{product.order_after_sales.text_part.aftersale_status_text}}</span>
														</p>
														<p v-if="product.purchase_msg" class="red" @click="showPurchaseMsg(product)">{{product.purchase_msg}}</p>
													</div>


                          <div class="goods_pay" v-if="pindex === 0">
                            <!-- <p class="t1">{{item.pay_type_text}}</p> -->
                            <p class="t2">实付：￥{{item.real_pay_amount}}</p>
                            <p class="t2">运费险：￥{{item.post_insurance_amount}}</p>
                            <p class="t2">平台优惠：￥{{ item.promotion_platform_amount }}</p>
                            <p class="t2">精选联盟：{{ item.c_biz == 1 ? '是' : '否' }}</p>
                            <p class="t2">预估代发费：￥{{item.shipping_fee}}</p>
                            <!-- <p class="t3">采购价</p>
                            <p class="t4">￥{{item.order_amount}}</p> -->
                          </div>
                          <div class="goods_buyer" v-if="pindex === 0">
                            <p>{{item.order_address.mask_name}}</p>
                            <p>{{item.order_address.mask_phone}}</p>
                            <p>{{item.order_address.province}}{{item.order_address.city}}{{item.order_address.town}}{{item.order_address.mask_detail}}

                              <el-tooltip class="item" effect="dark" content="点击查看" placement="top">
                                <i class="iconfont el-icon-view" @click="showAddressInfo(item.order_id)"></i>
                              </el-tooltip>
                            </p>
                          </div>

                          <div class="goods_status">
                            <p v-if="item.supplier_order_delivery_count>0 && pindex === 0"><a :href="'/uc_order_detail?order_id='+item.order_id" class="details">查看物流</a></p>

                            <p class="details" v-if="product.purchase_status==1&&[105,2,101].indexOf(parseInt(product.order_status)) != -1" @click="bindPurchase(product)">立即采购</p>
                            <p class="details" v-if="product.purchase_cancelable" @click="bindCancelPurchase(product)">取消采购</p>
                            <p class="details" v-if="product.purchase_status==1&&[105,2,101].indexOf(parseInt(product.order_status)) != -1" @click="transferOrderToPdd(product)">转多多采购</p>


                          </div>

												</div>

											</div>

											<div class="goods_status" v-if="false">
												<!-- <p v-if="[21,22,39,4].indexOf(parseInt(item.main_status)) == -1 && item.is_cancel == 0">{{item.purchase_status_text}}</p> -->

												<!-- <span class="text-warning" style="text-align: justify;" v-if="item.lack_type">
													<br>{{item.lack_type_text}}{{item.lack_day > 0 ? (item.lack_day+'天'):''}}
												</span> -->
												<!-- <p class="details" v-if="item.purchase_status==1&&(item.order_status==2||item.order_status==105) && item.is_cancel == 0" @click="order_cancel(item)">取消订单</p> -->

                        <div class="flex">

                        </div>

											</div>
											<div class="goods_status" v-if="false">
												<!-- <p v-if="item.purchase_status==1&&(item.order_status==2||item.order_status==105) && item.is_cancel == 0"><a href="javascript:;" class="details" @click="bindPurchase(item.order_id)">采购</a></p> -->
												<!-- <p v-if="item.purchase_status==2&&item.order_status==3 && item.is_cancel == 0"><a href="javascript:;" class="details" @click="bindReceipt(item.order_id)">确认收货</a></p> -->
												<!-- <p v-if="item.order_status==1 && item.is_cancel == 0"><a href="javascript:;" class="details" @click="payNow(item.order_id)">付款</a></p> -->
												<!-- <p><a :href="'/uc_order_detail?order_id='+item.order_id" class="details" target="_blank">订单详情</a></p> -->


											</div>
										</div>
										<div class="order_remarks">
											<div class="remarks_item">
												<p class="txt">卖家备注：</p>
												<p class="remarks">{{item.seller_words}}</p>
											</div>
											<div class="remarks_item">
												<p class="txt">客服备注：</p>
												<p class="remarks">{{item.service_words}}
													<i class="iconfont el-icon-edit" @click="showRemark2(item.order_id)"></i>
												</p>
											</div>
											<div class="remarks_item abnormal" v-if="item.is_exchange==1">

													<el-tooltip class="item" effect="dark" content="换货订单采购只收代发费" placement="top">
														<span class="sp_remark">换货订单</span>
													</el-tooltip>
											</div>
										</div>
									</li>
								</el-checkbox-group>
								<li class="nodata" v-if="page_data.total == 0">暂无数据</li>
							</ul>
							<div class="turn_page">
								<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[20,50,100,200,500,1000]" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 收货地址信息弹窗 -->
			<orderAddress @close="dialog.addressDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.addressDialog" :order_id.sync="order_id"></orderAddress>
			<!-- 标记备注弹窗 -->
			<orderRemark @close="dialog.remarkDialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.remarkDialog" :order_id.sync="order_id"></orderRemark>
			<!-- 售后详情弹窗 -->
			<el-dialog title="售后详情" :visible.sync="dialog.aftersaleDialog" width="70%" center>
				<orderAfterSales @close="dialog.aftersaleDialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.aftersaleDialog" :info.sync="order_product"></orderAfterSales>
			</el-dialog>
			<!-- 选择拼多多账号 -->
			<pddAccountConfirm ref="pddAccountConfirm"/>
			<modifyConfirm ref="modifyConfirm" @refresh="refresh"/>
			<modifyConfirmOrderNo ref="modifyConfirmOrderNo" @refresh="refresh"/>
			<!-- 订单支付弹窗 -->
			<orderPay @close="dialog.payDialog = false" @success="$router.go(0)" :show.sync="dialog.payDialog" :order_id.sync="order_id"></orderPay>
			<!-- 同步订单弹窗 -->
			<syncOrder @close="dialog.syncOrderDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.syncOrderDialog"></syncOrder>
			<!-- 客服备注弹窗 -->
			<serviceRemark @close="dialog.remark2Dialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.remark2Dialog" :order_id.sync="order_id"></serviceRemark>
			<!-- 采购弹窗 -->
			<orderServerPurchase ref="orderServerPurchase" @complete="refresh()"></orderServerPurchase>
		</div>
		<myFoot></myFoot>
		<connectGood ref="child" :dataArr="cg_data"></connectGood>
	</div>
</template>

<script>
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import orderAddress from '../../components/orderAddress/orderAddress';
import orderRemark from '../../components/orderRemark/orderRemark';
import serviceRemark from '../../components/serviceRemark/serviceRemark';
import connectGood from '../../components/connectGood/connectGood';
import orderAfterSales from '../../components/orderAfterSales/orderAfterSales';
import orderPay from '../../components/orderPay/orderPay';
import syncOrder from '../../components/syncOrder/syncOrder';
import Pagination from '../../components/pagination/pagination';
import pddAccountConfirm from "@/pages/uc_order/components/pdd_account_confirm/index.vue";
import modifyConfirm from "@/pages/uc_order/components/modify_confirm/index.vue";
import modifyConfirmOrderNo from "@/pages/uc_order/components/modify_confirm_order_no/index.vue";
import orderServerPurchase from "@/pages/us_order/components/purchase.vue";
import {Loading} from 'element-ui';
import {mapActions} from "vuex";

export default {
	name: "ucenterOrders",
	data() {
		return {
			order_id: 0,
			options: [],
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			arrStatus: [],
			shopTypeList: [],
			arrStar: [],
			arrShop: [],
			arrAbnormal: [],
			arrAfterSales: [],
			arrPddStatus: [],
			checkAll: false,
			checkList: [],
			isLoading: false,
			list: [],
			page_data: {
				limit: 10,
				page: 1,
				total: 0,
			},
			total_partner_profit: 0,
			searchData: {},
			dialog: {
				addressDialog: false,
				aftersaleDialog: false,
				remarkDialog: false,
				remark2Dialog: false,
				payDialog: false,
				syncOrderDialog: false,
			},
			cg_data: "",
			order_product: [],
			is_decrypt: 0,
			decrypt_state: 1,
			decrypt_msg: '',
			loading_service_id: 0,
			isHideOrderInfo: false
		}
	},
	components: {
		myHead, myFoot, ucMenu, orderAddress, connectGood, orderAfterSales, orderRemark, serviceRemark, orderPay, Pagination, syncOrder, pddAccountConfirm, modifyConfirm, modifyConfirmOrderNo,orderServerPurchase
	},
	mounted(){
		const isHideInfo = localStorage.getItem('isHideInfo')
		if(isHideInfo == 1){
			this.isHideOrderInfo = true
		}
		// if(this.userinfo){
		// 	this.refreshUserinfo()
		// }
	},
	created() {
		var query = this.$route.query
		if (query.status) {
			this.searchData.order_status = Number(query.status)
		}
		if (query.after_sale) {
			this.searchData.after_sale_status = Number(query.after_sale)
		}
		this.getList()
	},
	methods: {
		callCG(arr) {//打开子组件店铺列表
			this.$refs.child.showConnectGood()
			this.cg_data = JSON.stringify(arr)
		},
		...mapActions({
			getOrderServerList: "ucenter/getOrderServerList",
			opOrderServerPurchase: "ucenter/opOrderServerPurchase",
			getOrderServerFilterData: "ucenter/getOrderServerFilterData",
			opOrderServerCancelPurchase: "ucenter/opOrderServerCancelPurchase",
      opTransferOrderToPdd: "ucenter/opTransferOrderToPdd",
			getOrderManageAddressInfo: "ucenter/getOrderManageAddressInfo",
			getOrderManageDetail: "ucenter/getOrderManageDetail",
			opOrderManageBatPurchase: "ucenter/opOrderManageBatPurchase",
			opOrderManageBatAbnormal: "ucenter/opOrderManageBatAbnormal",
			opOrderManageReceipt: "ucenter/opOrderManageReceipt",
			opDdShopRefreshDecrypt: "ucenter/opDdShopRefreshDecrypt",
			opUnDecrypt: "ucenter/opUnDecrypt",
			opReDecrypt: "ucenter/opReDecrypt",
			opOrderManageDeleteProduct: "ucenter/opOrderManageDeleteProduct",
			opOrderManageDelPddOrder: "ucenter/opOrderManageDelPddOrder",
			opOrderManageSendGiftOrder: "ucenter/opOrderManageSendGiftOrder",
			opOrderManageSetNotDealOrder: "ucenter/opOrderManageSetNotDealOrder",
			opOrderManageRepealPurchase: "ucenter/opOrderManageRepealPurchase",
			opOrderManageNeedSyncPddOrder: "ucenter/opOrderManageNeedSyncPddOrder",
			opOrderManageUpdateOrderAfterSale: "ucenter/opOrderManageUpdateOrderAfterSale",
			opOrderManageCancelDelete: "ucenter/opOrderManageCancelDelete",
			opRefreshReturnAddress: "ucenter/opRefreshReturnAddress",
			opSetSellerWords: "ucenter/opSetSellerWords",
			opUpdatePddAccount: "ucenter/opUpdatePddAccount",
			opUpdatePddOrderNo: "ucenter/opUpdatePddOrderNo",
			opUpdateOrderProduct: "ucenter/opUpdateOrderProduct",
			opUpdateBuyMode: "ucenter/opUpdateBuyMode",
		}),
		initFilterData() {
			this.getOrderServerFilterData({
				data: this.searchData, success: (res) => {
					if (res.code === 200) {
						// console.log('get goods filter data',res)
						this.arrStatus = res.data.arr_status
						this.arrStar = res.data.arr_star
						this.arrAbnormal = res.data.arr_abnormal
						this.arrAfterSales = res.data.arr_after_sales
						this.arrShop = res.data.arr_shop
						this.shopTypeList = res.data.shop_types
					}
				}
			})
		},
		//重置搜索
		resetSearch() {
			this.searchData = {}
			this.checkAll = false
			this.checkList = []
			this.getList()
		},
		//刷新列表
		refresh(nowPage = true) {
			if (!nowPage) {
				this.page_data.page = 1
			}
			this.checkAll = false
			this.checkList = []
			this.getList()
		},
		changeStatus(val) {
			this.searchData.order_status = val
			this.refresh(false)
		},
		doSearch() {
			this.page_data.page = 1
			this.checkAll = false
			this.checkList = []
			this.getList()
		},
		getList(showLoading = true) {
			if (showLoading) this.isLoading = true
			let loadingInstance = Loading.service({fullscreen: true});

			let param = {limit: this.page_data.limit, page: this.page_data.page}
			param = Object.assign(param, this.searchData)
			this.getOrderServerList({
				data: param, success: (res) => {
					if (res.code === 200) {
						// console.log('get order list',res)
						this.list = res.data.data
						this.page_data.total = res.data.total
						this.is_decrypt = res.data.is_decrypt
						this.decrypt_state = res.data.decrypt_state
						this.decrypt_msg = res.data.decrypt_msg
						this.total_partner_profit = res.data.total_partner_profit
						this.initFilterData()
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
					this.isLoading = false
					loadingInstance.close()
				}
			})
		},
		showAddressInfo(id) {
			this.order_id = id
			this.dialog.addressDialog = true
		},
		showOrderInfo(){
			//获取缓存数据
			const isHideInfo = localStorage.getItem('isHideInfo');

			if (isHideInfo == 1) {
				// 如果存在缓存数据，则将其解析为 JSON 对象
				localStorage.setItem('isHideInfo',0)
				this.isHideOrderInfo = false
			} else {
				localStorage.setItem('isHideInfo',1)
				this.isHideOrderInfo = true
			}
		},
		showRemark(id) {
			this.order_id = id
			this.dialog.remarkDialog = true
		},
		showRemark2(id) {
			this.order_id = id
			this.dialog.remark2Dialog = true
		},
		showAfterSaleInfo(order_product) {
			this.order_product = order_product
			this.dialog.aftersaleDialog = true
		},
		showPurchaseMsg(order_product) {
			this.$alert(order_product.purchase_msg, '采购状态', {
				type: 'warning',
				center: true
			});
		},
		bindCopy(text) {
			var str = ''
			var input = document.createElement("input"); // 创建input对象
			input.value = text; // 设置复制内容
			document.body.appendChild(input); // 添加临时实例
			input.select(); // 选择实例内容
			document.execCommand("Copy"); // 执行复制
			document.body.removeChild(input); // 删除临时实例
			this.$message({
				message: '复制成功',
				type: 'success'
			});

		},
    transferOrderToPdd(order_product){
      let that = this
      this.$confirm('确认转多多采购操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        that.isLoading = true
        let loadingInstance = Loading.service({fullscreen: true});
        this.opTransferOrderToPdd({
          data: {id: order_product.id},
          success: (res) => {
            that.isLoading = false
            loadingInstance.close()
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
              this.refresh()
            }
          }
        })
      }).catch((res) => {
        console.log(res)
        that.isLoading = false
        loadingInstance.close()
      });
    },
		//全选
		bindCheckAll() {
			let checkAll = this.checkAll
			let list = this.list
			let checkList = []
			if (checkAll) {
				for (var i in list) {
					if (checkAll) {
						checkList.push(list[i].order_id)
					}
				}
			}
			this.checkList = checkList
		},
		//单项选
		bindCheckList() {
			let checkList = this.checkList
			if (checkList.length == this.list.length) {
				this.checkAll = true
			} else {
				this.checkAll = false
			}
		},
		//立即采购
		bindPurchase(product) {

			this.postPurchcase(product.id,2)
		},
		//批量采购
		bindBatPurchase() {
			let checkList = this.checkList
			let ids = checkList.join(',')
			this.postPurchcase(ids,1)
		},
		//取消采购
		bindCancelPurchase(order_product) {
			let that = this
			this.$confirm('确认取消采购操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.isLoading = true
				let loadingInstance = Loading.service({fullscreen: true});
				this.opOrderServerCancelPurchase({
					data: {id: order_product.id},
					success: (res) => {
						that.isLoading = false
						loadingInstance.close()
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
							this.refresh()
						}
					}
				})
			}).catch((res) => {
				console.log(res)
				that.isLoading = false
				loadingInstance.close()
			});
		},
		// 批量删除
		bindBatDelete() {
			let checkList = this.checkList
			let ids = checkList.join(',')
			this.postDeleteOrder(ids)
		},
		cancelDelete(row) {
			this.$confirm('确认恢复操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageCancelDelete({
					data: {ids: row.id}, success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		postDeleteOrder(ids) {
			this.$confirm('确认删除操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageDeleteProduct({
					data: {ids: ids},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		//采购请求
		postPurchcase(ids,id_type) {
			let that = this
			let param = {ids: ids,id_type:id_type}
			if(this.isLoading) return
			this.isLoading = true
			let loadingInstance = Loading.service({fullscreen: true});
			this.opOrderServerPurchase({
				data: param, success: (res) => {
					if (res.code === 200) {
						console.log('get order list',res)
						this.$refs.orderServerPurchase.open(res.data)
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
					this.isLoading = false
					loadingInstance.close()
				}
			})
		},
		//订单导出
		orderExport() {
			if (this.isLoading) return
			this.$confirm('确认导出订单操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.isLoading = true
				let loadingInstance = Loading.service({fullscreen: true});
				let param = {limit: this.page_data.limit, page: this.page_data.page, is_export: 1, order_ids: this.checkList}
				Object.assign(param, this.searchData)
				this.getOrderServerList({
					data: param, success: (res) => {
						this.isLoading = false;
						loadingInstance.close()
						if (res.code === 200) {
							window.open(res.data)
							// window.location.href = res.data
						} else {
							this.$message({message: res.msg, type: 'error',});
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		sendGiftOrder(id = null) {
			let checkList = this.checkList
			if (id !== null) {
				checkList = [id]
			}
			let ids = checkList.join(',')
			if (checkList.length === 0) {
				this.$message({message: '请勾选订单',type: 'error'})
				return;
			}
			this.$confirm('确认发送礼品单操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageSendGiftOrder({
					data: {ids: ids},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		setNotDeal(id = null) {
			let checkList = this.checkList
			if (id !== null) {
				checkList = [id]
			}
			let ids = checkList.join(',');
			if (checkList.length === 0) {
				this.$message({message: '请勾选订单',type: 'error'})
				return;
			}
			this.$confirm('确认完结该订单? 确认后不可逆', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageSetNotDealOrder({
					data: {ids: ids},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		datePick() {
			console.log(111)
		},
		//放弃解密
		unDecrypt(ids) {
			var that = this
			this.$confirm('确认放弃解密？', '提示', {
				confirmButtonText: 'YES',
				cancelButtonText: 'NO',
				type: 'info',
				center: true
			}).then(() => {

				that.opUnDecrypt({
					data: {ids: ids}, success: (res) => {
						if (res.code == 200) {
							that.$message({
								type: 'success',
								message: res.msg
							})
							that.refresh()
						} else {
							that.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})

			})
		},
		//批量放弃解密
		batUnDecrypt() {
			let checkList = this.checkList
			let ids = checkList.join(',')
			this.unDecrypt(ids)
		},
		//恢复解密
		reDecrypt(ids) {
			var that = this
			this.$confirm('确认恢复解密？', '提示', {
				confirmButtonText: 'YES',
				cancelButtonText: 'NO',
				type: 'info',
				center: true
			}).then(() => {
				that.opReDecrypt({
					data: {ids: ids}, success: (res) => {
						if (res.code == 200) {
							that.$message({
								type: 'success',
								message: res.msg
							})
							that.refresh()
						} else {
							that.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})

			})
		},
		//批量恢复解密
		batReDecrypt() {
			let checkList = this.checkList
			let ids = checkList.join(',')
			this.reDecrypt(ids)
		},
		needSyncOrder(row) {
			this.$confirm('确认同步PDD操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageNeedSyncPddOrder({
					data: {ids: row.id},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		afterSales(row) {
			this.$confirm('确认同步抖店操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageUpdateOrderAfterSale({
					data: {ids: row.id},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		repealPurchase(row) {
			this.$confirm('确认重新采购操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageRepealPurchase({
					data: {ids: row.id},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});

		},
		refreshReturnAddress(row) {
			this.$confirm('确定重新获取地址吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opRefreshReturnAddress({
					data: {ids: row.id},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		editProductCode(row,index) {
			let pdd_sku_id = ''
			this.$refs.modifyConfirm.open(
				'商品编码',
				row.pdd_sku_id ?? row.pdd_code,
				this.opUpdateOrderProduct,
				(val) => {
					pdd_sku_id = val
					return {
						pdd_sku_id: val,
						id: row.id
					}
				},
				(res) => {
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})
						// this.refresh(true)
						this.list[index].pdd_sku_id = pdd_sku_id
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}
			)
		},
		editPddAccount(row) {
			this.$refs.modifyConfirm.open(
				'采购账号',
				row.pdd_order.account,
				this.opUpdatePddAccount,
				(val) => {
					return {
						account: val,
						ids: row.id
					}
				},
				(res) => {
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})
						this.refresh()
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}
			)
		},
		editPddOrderNo(row) {
			this.$refs.modifyConfirmOrderNo.open(
				'设置采购单号',
				{order_no: row.pdd_order?.order_id, account: row.pdd_order?.account},
				this.opUpdatePddOrderNo,
				(val) => {
					return {
						pdd_order_no: val.pdd_order_no,
						pdd_account_id: val.pdd_account_id,
						ids: row.id
					}
				},
				(res) => {
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})
						this.refresh()
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}
			)
		},
		editBuyMode(row){
			this.$confirm('确定切换采购模式吗? 切换后请重新启动任务', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.opUpdateBuyMode({data:{ids: row.id},success:(res)=>{
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})
						this.refresh()
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}})
			}).catch(() => {
			});
		},
		editSellerWords(row) {
			this.$refs.modifyConfirm.open(
				'商家留言',
				row.order.seller_words,
				this.opSetSellerWords,
				(val) => {
					return {
						seller_words: val,
						order_id: row.order_id
					}
				},
				(res) => {
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})
						this.refresh()
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				},
				'textarea'
			)
		},
		openImg(row) {
			console.log(row)
			let htm = '<img style="object-fit: cover;margin-right: 10px;max-height:70vh;" src="' + row.product_pic + '" alt="">'
			htm += '<div style="margin-top:10px;font-size:16px;">'+row.spec_value+'</div>';
			htm += '<div style="margin-top:5px;font-size:16px;">实付:￥'+row.pay_amount+'</div>';
			this.$alert(htm, row.product_name, {
				dangerouslyUseHTMLString: true,
				showClose: false,
				confirmButtonText: '关闭',
				closeOnClickModal: true,
				customClass: 'zdy-message-box'
			});
		},
		showOriginalOrder(dd_order_id, type = 1) {
			console.log(dd_order_id.substring(0, dd_order_id.length - 1));
			if (type === 2) {
				this.searchData.dd_order_id = dd_order_id;
			} else {
				this.searchData.dd_order_id = dd_order_id.substring(0, dd_order_id.length - 1);
			}
			this.refresh();
		}
	}
}
</script>

<style lang="less" scoped>
.wrap .wrap_body {
	display: flex;
	flex-direction: column;
}

.center {
	display: flex;
	flex: 1;
}

.ucenter_main {
	padding: 30px 0 40px;
	display: flex;
	justify-content: space-between;
	flex: 1;
}

.right_con {
	width: 980px;
	background: #fff;
}

.goods_main {
	padding: 36px 40px 46px;
	min-height: 70vh;
}

.select_wrap {
	margin-top: 24px;
	display: flex;
	flex-wrap: wrap;
}

.select_wrap .mr {
	margin-right: 15px;
}

.select_wrap .w290 {
	width: 290px;
	margin-top: 14px;
	margin-right: 15px;
}

.select_wrap .w290:nth-child(3n) {
	margin-right: 0;
}

.select_wrap .label_title {
	width: 96px;
	height: 100%;
	font-size: 12px;
	color: #999;
	display: flex;
	align-items: center;
	padding-left: 6px;
}

.select_wrap .label_title .icon-shuoming {
	font-size: 12px;
	color: #999;
	margin-left: 2px;
}

.tabs_wrap {
	width: 100%;
	height: 60px;
	border-bottom: 1px solid #eee;
	display: flex;
	// justify-content: space-between;
}

.tabs_wrap .tab {
	height: 100%;
	padding: 30px 22px 0;
	position: relative;
	line-height: 1;
	cursor: pointer;
	font-size: 14px;
	color: #666;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;
}

.tabs_wrap .tab .mark {
	position: absolute;
	vertical-align: middle;
	display: inline-block;
	right: 0px;
	bottom: 10px;
}

.tabs_wrap .tab.active {
	font-weight: bold;
	color: var(--red);
}

.tabs_wrap .tab.active::after {
	content: '';
	width: 100%;
	height: 3px;
	background: var(--red);
	position: absolute;
	left: 0;
	bottom: 0;
	z-index: 2;
}

.tabs_wrap .tab .iconfont {
	font-size: 14px;
	color: #1966ff;
	margin-left: 4px;
}

.totals_btn {
	margin-top: 14px;
	display: flex;
	align-items: center;
}

.totals_btn .totals {
	font-size: 12px;
	color: #333;
	padding-right: 16px;
	margin-right: 16px;
	line-height: 1;
	border-right: 1px solid #ccc;
}

.total_profit {
	margin-left: 10px;
	font-size: 14px;
}

.totals_btn .decrypt_msg {
	font-size: 14px;
	color: var(--red);
	padding-left: 10px;
}

.list_title {
	width: 100%;
	height: 50px;
	background: #f9f9f9;
	margin-top: 10px;
	display: flex;
	align-items: center;
	font-size: 12px;
	color: #666;
	line-height: 1;
}

.list_title .checkall {
	margin-left: 20px;
}

.list_title .t1 {
	margin-left: 10px;
	width: 182px;
}

.list_title .t2 {
	margin: 0 20px;
	width: 60px;
	text-align: right;
}

.list_title .t3 {
	margin: 0 10px;
	width: 140px;
	text-align: left;
}

.list_title .t4 {
	margin-left: 20px;
	width: 100px;
	text-align: right;
}

.list_title .t5 {
	margin: 0 20px;
	width: 130px;
	text-align: left;
}

.list_title .t6 {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: left;
}

.list_title .t7 {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: right;
}

.list_title .t8 {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: right;
}

.order_list li {
	margin-top: 10px;
	font-size: 12px;
}
.order_list li .info_top {
	background: #fff6f7;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.order_list li .info_top .order_flag .flag_box {
	white-space: nowrap;
	padding: 2px 7px;
	color: #fff;
	background: red;
	border-radius: 3px;
	cursor: pointer;
}
.order_list li .info_top .order_flag .flag_box.old {
	background: #0990c0;
}
.order_list li .order_nums {
	width: 100%;
	height: 40px;
	background: #fff6f7;
	display: flex;
	align-items: center;
	position: relative;
}

.order_list li .order_nums .btn-remark {
	position: absolute;
	right: 20px;
	cursor: pointer;
	font-size: 14px;
}

.order_list li .order_nums .check_box {
	margin-left: 20px;
}

.order_list li .order_nums .num {
	display: flex;
	align-items: center;
	margin-left: 12px;
	color: #666666;
}

.order_list li .order_nums .num .iconfont {
	cursor: pointer;
	font-size: 14px;
	color: #666;
	margin-left: 8px;
}

.order_list li .order_nums .date {
	margin-left: 26px;
	color: #666666;
}

.order_list li .order_nums .maoli {
	margin-left: 30px;
	color: #666666;
}

.order_list li .order_info {
	padding: 20px 0;
	border-bottom: 1px dashed #eee;
	display: flex;
	align-items: flex-start;
	line-height: 1;
}

.order_list li .order_info .order_product {
	display: flex;
	flex-direction: column;
}

.order_list li .order_info .order_product .product_item {
	display: flex;
	padding-bottom: 20px;
}

.order_list li .order_info .order_product .product_item:last-child {
	padding-bottom: 0;
}

.order_list li .order_info .goods_info {
	width: 242px;
	display: flex;
	margin-left: 20px;
}

.order_list li .order_info .goods_info .img_box {
	width: 48px;
	height: 48px;
	background-color: #eeeeee;
	border-radius: 6px;
	overflow: hidden;
	cursor: pointer;
}

.order_list li .order_info .goods_info .con_box {
	flex: 1;
	width: 0;
	margin-left: 10px;
}

.order_list li .order_info .goods_info .con_box .title {
	line-height: 16px;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
}

.order_list li .order_info .goods_info .con_box .t1 {
	color: #999999;
	margin-top: 12px;
	line-height: 14px;
}

.order_list li .order_info .goods_info .con_box .t2 {
	color: #999999;
	margin-top: 8px;
}

.order_list li .order_info .goods_info .con_box .t2 .sp_remark {
	display: inline-block;
	max-width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	color: #f0b92c;
}

.order_list li .order_info .goods_info .con_box .stock_msg {
	color: var(--red);
	margin-top: 8px;
	display: flex;
	justify-content: space-between;
}

.order_list li .order_info .goods_info .con_box .guanlian {
	color: #1966ff;
	margin-top: 8px;
	cursor: pointer;
}

.order_list li .order_info .goods_info .con_box .guanlian:hover {
	text-decoration: underline;
}

.order_list li .order_info .goods_num {
	margin: 0 20px;
	width: 60px;
	text-align: right;
}

.order_list li .order_info .goods_num .t1 {
	color: #333333;
}

.order_list li .order_info .goods_num .t2 {
	color: #999999;
	margin-top: 10px;
}
.order_list li .order_info .goods_num .t3 {
	color: var(--red);
	margin-top: 10px;
	cursor: pointer;
}
.order_list li .order_info .goods_sales {
	margin: 0 10px;
	width: 140px;
	text-align: left;
}

.order_list li .order_info .goods_sales > p {
	line-height: 18px;
	color: #333;
}

.order_list li .order_info .goods_sales > p.red {
	color: var(--red);
	cursor: pointer;
}

.order_list li .order_info .goods_pay {
	margin-left: 20px;
	width: 100px;
	text-align: right;
}

.order_list li .order_info .goods_pay .t1 {
	color: #333333;
}

.order_list li .order_info .goods_pay .t2 {
	color: #333333;
	margin-top: 10px;
}

.order_list li .order_info .goods_pay .t3 {
	color: #666666;
	margin-top: 20px;
}

.order_list li .order_info .goods_pay .t4 {
	color: #666666;
	margin-top: 10px;
}

.order_list li .order_info .goods_buyer {
	margin: 0 20px;
	width: 130px;
	text-align: left;
}

.order_list li .order_info .goods_buyer .t1 {
	color: #333333;
}

.order_list li .order_info .goods_buyer .t2 {
	color: #333333;
	margin-top: 10px;
}

.order_list li .order_info .goods_buyer .t3 {
	color: #666666;
	margin-top: 20px;
}

.order_list li .order_info .goods_buyer .t4 {
	color: #666666;
	margin-top: 10px;
}

.order_list li .order_info .goods_buyer > p {
	line-height: 18px;
	color: #666;
}

.order_list li .order_info .goods_buyer > p .iconfont {
	cursor: pointer;
	font-size: 12px;
	color: #666;
	margin-left: 8px;
}

.order_list li .order_info .goods_status {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: left;
}

.order_list li .order_info .goods_status:last-child {
	text-align: right;
}

.order_list li .order_info .goods_status > p {
	margin-bottom: 10px;
}

.order_list li .order_info .goods_status .details {
	color: #f0413e;
	cursor: pointer;
}

.order_list li .order_info .goods_status .details:hover {
	text-decoration: underline;
}

.order_list li .order_info .goods_status p > a {
	color: #f0413e;
	cursor: pointer;
}

.order_list li .order_info .goods_status p > a:hover {
	text-decoration: underline;
}

.order_list li .order_remarks {
	padding: 10px 0;
	border-bottom: 1px solid #eee;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.order_list li .order_remarks .remarks_item {
	display: flex;
	flex: 1;
}

.order_list li .order_remarks .remarks_item.abnormal {
	width: 100px;
	flex: unset;
	text-align: right;
	color: #f0b92c;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 10px;
	font-weight: bold
}

.order_list li .order_remarks .txt {
	font-size: 12px;
	color: #999999;
	line-height: 18px;
	max-width: 110px;
	box-sizing: border-box;
	padding-left: 10px;
}

.order_list li .order_remarks .remarks {
	flex: 1;
	width: 0;
	font-size: 12px;
	color: #333;
	line-height: 18px;
}

.turn_page {
	display: flex;
	justify-content: flex-end;
	margin-top: 30px;
}

.order_list li .order_remarks .remarks i {
	cursor: pointer;
}

.order_list li .check_box {
	margin-left: 20px;
	height: 48px;
	display: flex;
	align-items: center;
}

/deep/ .order_list li .check_box .el-checkbox__label {
	display: none !important;
}

.order_list .shop_name {
	max-width: 120px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	display: inline-block;
	margin-right: 5px;
}
</style>
<style>
.has-time .el-button {
	padding: 7px 15px;
}

.select_wrap .el-button {
	margin-top: 14px;
}

.select_wrap .el-range-editor .el-range-input {
	font-size: 1em;
}

.select_wrap .el-input--prefix .el-input__inner {
	padding-left: 96px !important;
	height: 34px !important;
	line-height: 34px !important;
	font-size: 12px !important;
}

.el-select .el-input.is-focus .el-input__inner, .el-select .el-input__inner:focus {
	border-color: var(--red);
}

.el-select-dropdown__item.selected {
	color: var(--red);
}

.select_wrap .el-input--prefix .el-input__inner:focus {
	border-color: var(--red);
}

.el-date-editor .el-range-separator {
	line-height: 26px;
}

.el-date-editor {
	width: 290px !important;
	height: 34px !important;
	line-height: 34px !important;
	font-size: 12px !important;
	margin-top: 14px;
}

.el-range-editor.is-active, .el-range-editor.is-active:hover {
	border-color: var(--red);
}

.el-date-table td.end-date span, .el-date-table td.start-date span {
	background-color: var(--red);
}

.el-date-table td.today span {
	color: var(--red);
}

.el-picker-panel__icon-btn:hover, .el-date-table td span:hover, .el-date-table td div:hover, .el-date-table td.available:hover, .el-picker-panel__shortcut:hover {
	color: var(--red);
}

.el-button {
	color: #333;
	border-color: #ddd;
}

.el-button--small {
	padding: 7px 15px;
}

.el-checkbox {
	color: #666;
	display: flex;
	align-items: center;
}

.el-checkbox__inner {
	border-color: #ddd;
	width: 16px;
	height: 16px;
}

.el-checkbox__input {
	display: flex;
}

.el-checkbox__label {
	font-size: 12px;
	line-height: 1;
}

.el-checkbox__inner::after {
	height: 9px;
	left: 5px;
}

.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
	height: 4px;
}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__inner:hover, .el-checkbox__input.is-focus .el-checkbox__inner, .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus {
	border-color: var(--red);
}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked + .el-checkbox__label, .el-pager li.active, .el-pagination button:hover, .el-pager li:hover {
	color: var(--red);
}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: var(--red);
}

.el-input__icon {
	line-height: unset;
}

.el-button--primary, .el-button--primary:hover {
	background-color: var(--red) !important;
	border-color: var(--red) !important;
	color: #fff !important;
}

.el-button:hover {
	border-color: var(--red) !important;
	background-color: rgba(240, 65, 62, 0.1) !important;
	color: var(--red) !important;
}

.el-date-editor--datetimerange .el-icon-time {
	line-height: 28px;
}

.el-date-editor .el-range-separator {
	width: 20px;
}
.red{
	color: var(--red) !important;
}
</style>
